module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty9.9a7a04ed.jpg";